import { FilteredCreditApplication, RequiredDocumentWithStatus } from '@applyonline/shared'
import { scrollToTop } from '@applyonline/shared/utils'
import WorksheetPage from '../../../containers/Worsheet/WorksheetPage'
import { useLayoutEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import OverviewPage from './OverviewPage/OverviewPage'
import ApplicantIncomePage from './components/ApplicantIncomePage'
import CreditSummaryPage from './components/CreditSummaryPage'
import CustomerFeedbackPage from './components/CustomerFeedbackPage'
import DocumentsPage from './components/DocumentsPage'

interface Props {
  creditApp: FilteredCreditApplication
  requiredDocuments: RequiredDocumentWithStatus[]
}

const HardHitApprovedResultPage = ({ creditApp, requiredDocuments }: Props) => {
  useLayoutEffect(scrollToTop, [])

  return (
    <Routes>
      <Route path="credit-summary" element={<CreditSummaryPage creditApp={creditApp} />} />
      <Route path="required-documents" element={<DocumentsPage creditApp={creditApp} />} />
      <Route path="feed-back" element={<CustomerFeedbackPage creditApp={creditApp} />} />

      <Route path="incomes" element={<ApplicantIncomePage creditApp={creditApp} />} />
      <Route path="worksheet/:step?" element={<WorksheetPage creditApp={creditApp} />} />

      <Route index path="*" element={<OverviewPage creditApp={creditApp} requiredDocuments={requiredDocuments} />} />
    </Routes>
  )
}

export default HardHitApprovedResultPage
